import { api, ensureApiAuthenticated } from '../services/api';

export interface SealedSearchHit {
  sealed_uuid: string;
  name: string;
  set: string;
  set_name?: string | null;
  release_date?: string | null;
  product_type: string;
}

export interface SealedSearchResponse {
  query: string;
  count: number;
  truncated: boolean;
  items: SealedSearchHit[];
}

export interface SealedMissingLine {
  kind: string;
  label: string;
  qty: number;
  card_uuid?: string | null;
  finish?: string | null;
}

export interface SealedExtraLine {
  kind: string;
  qty: number;
  label: string;
}

export interface SealedContentLine {
  card_uuid: string;
  name: string;
  set?: string | null;
  collector_number?: string | null;
  finish: string;
  qty: number;
  source: string;
  optional: boolean;
  priced: boolean;
  unit_gross?: number | null;
  unit_net?: number | null;
  line_gross?: number | null;
  line_net?: number | null;
  image_url?: string | null;
  scryfall_id?: string | null;
}

export interface SealedLookupItem {
  sealed_uuid: string;
  name: string;
  set?: string | null;
  set_name?: string | null;
  release_date?: string | null;
  product_type?: string | null;
  qty: number;
  counted_as?: 'sealed' | 'crack' | null;
  sealed_gross?: number | null;
  sealed_net?: number | null;
  crack_gross?: number | null;
  crack_net?: number | null;
  complete: boolean;
  missing_count: number;
  on_hand_qty: number;
  acquisition_cost_sum?: number | null;
  unit_cost?: number | null;
  recommendation?: string | null;
  missing: SealedMissingLine[];
  extras: SealedExtraLine[];
  contents: SealedContentLine[];
  children: SealedLookupItem[];
}

export interface SealedLookupResponse {
  tcg_fee_rate: number;
  item: SealedLookupItem;
}

export async function searchSealedProducts(
  q: string,
  limit = 20,
): Promise<SealedSearchResponse> {
  await ensureApiAuthenticated();
  const response = await api.get<SealedSearchResponse>('/lookup/sealed', {
    params: { q, limit },
  });
  return response.data;
}

export async function fetchSealedProduct(sealedUuid: string): Promise<SealedLookupResponse> {
  await ensureApiAuthenticated();
  const response = await api.get<SealedLookupResponse>(
    `/lookup/sealed/${encodeURIComponent(sealedUuid)}`,
  );
  return response.data;
}
